export default {
  saveSuccessMsg: '保存成功！',
  changeLanguageTips: '切换语言成功',
  modifyPwdSuccess: '密码修改成功！',
  noFileMsgOrError: '没有文件信息或文件报错',
  immutableInfo: '该学生信息不可修改！',
  unknownError: '未知错误，请联系管理员！',
  expired: '认证已过期',
  deleteSuccess: '删除成功',
  addSuccess: '新增成功',
  editSuccess: '编辑成功',
  setSuccess: '设置成功',
  removeSuccess: '移除成功',
  removeSuperiorConfirm: '您确定要为{name}移除所勾选的业务上司吗？',
  appendSuperiorConfirm: '您确定要将勾选的人设置为{name}的业务上司吗？',
  setSuperiorMessage: '请先勾选您要设置的业务上司',
  removeSuperiorMessage: '请先勾选您要移除的业务上司',
  uploadLimit: "上传文件只能是PDF格式",
  uploadSize: "上传文件不能超过{limit}M",
  uploadFail: "上传失败",
  delMsgFile: "您确定要删除该文件吗？",
  deleteSucc: "删除成功",
  deleteFail: "删除失败",
  differentialSubmissionConfirm: "您确定要差异提交当前账单吗？",
  differentialSubmissionConfirm2: '请先勾选您要差异提交当前账单选项！',
  differentialSubmissionSuccess: "差异提交成功",
  pleaseSelectAllUnsettledPayBackStatement: '请先勾选所有负账单再点击提交！',
  unsettledPayBackStatementMessage:'负账单差异提交审核中，无法提交结算！',
  pleaseSelectBankInfo: '请选择银行信息！',
  pleaseSelectSettleMethod: '请选择结算方式！',
  pleaseCompleteSettleInfo: '请完善结算币种信息！',
  pleaseCompleteOriginalCurrency: '请完善原币种信息！',
  uploadFileTips: '仅支持PDF格式文件，请重新上传符合格式要求的文件！',
  submitAndDownloadSuccess: '提交并下载成功！',
  downloadSuccess: '下载成功！',
  pleaseSelectSettledMessage: '请先勾选您需要结算的佣金！',
  businessOverviewMessage: '请先选择年份！',
  selectInstitutionMessage: ' 院校名称和申请国家/地区是联动的，请选择申请国家/地区',
}
